export default __webpack_public_path__ + "static/media/PigglywigglyLogo2.9be6b294.png";